import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {BreadcrumbErrorsFactory} from '../Errors/factory.js'
import BreadcrumbRepositoriesFactory from '../Repositories/factory.js'
import BreadcrumbValueObjectsFactory from '../ValueObjects/factory.js'

class GetAdsDynamicBreadcrumbsBreadcrumbUseCase extends UseCase {
  #pageConfig
  #repository
  #breadcrumbRequestObjectValueObject
  #isAdDetailPage = pageName => {
    const {ADS_DETAIL_PAGE_NAME, ADS_DETAIL_PREVIEW_PAGE_NAME} = this.#pageConfig

    return pageName === ADS_DETAIL_PAGE_NAME || pageName === ADS_DETAIL_PREVIEW_PAGE_NAME
  }

  async #getAdDetailBreadcrumbs({params}) {
    const breadcrumbRequestObjectValueObject = this.#breadcrumbRequestObjectValueObject({
      ...params
    })
    const [repositoryError, repositoryResponse] = await this.#repository.getBreadcrumbs(
      breadcrumbRequestObjectValueObject
    )

    if (repositoryError) return Promise.reject(repositoryError)

    return repositoryResponse.toJSON()
  }

  constructor({pageConfig, repository, breadcrumbRequestObjectValueObject}) {
    super()
    this.#pageConfig = pageConfig
    this.#repository = repository
    this.#breadcrumbRequestObjectValueObject = breadcrumbRequestObjectValueObject
  }

  static create({config}) {
    return new GetAdsDynamicBreadcrumbsBreadcrumbUseCase({
      pageConfig: config.get('page'),
      repository: BreadcrumbRepositoriesFactory.httpBreadcrumbRepository({config}),
      breadcrumbRequestObjectValueObject: BreadcrumbValueObjectsFactory.breadcrumbRequestValueObject
    })
  }

  @tracer({metric: 'GetAdsDynamicBreadcrumbsBreadcrumbUseCase#execute'})
  @AsyncInlineError()
  async execute({pageName, params = {}}) {
    if (this.#isAdDetailPage(pageName)) {
      return this.#getAdDetailBreadcrumbs({params})
    }

    return Promise.reject(
      BreadcrumbErrorsFactory.getBreadcrumbs(
        `[GetAdsDynamicBreadcrumbsBreadcrumbUseCase] pageName "${pageName}" is not a valid breadcrumbs ads page`
      )
    )
  }
}

export const factory = GetAdsDynamicBreadcrumbsBreadcrumbUseCase.create
